import { clsx } from 'clsx';
import JxtCheckbox from '../../JxtCheckbox';
import { getCheckedState } from '../helpers';
import { ITreeNode } from '../types';

export const TreeNode = ({
  node,
  checkedValue,
  expandedValue,
  onToggleChecked,
  onToggleExpanded,
  depth,
}: ITreeNode) => {
  const isBranch = (node.children?.length ?? 0) > 0;
  const checkedState = getCheckedState(node, checkedValue);
  const isChecked = checkedState === true;
  const isIndeterminate = checkedState === 'indeterminate';

  if (isBranch) {
    const isOpen = expandedValue.includes(node.value);
    return (
      <li className="list-none">
        <div className="flex items-center gap-2">
          {/* Chevron trigger */}
          <button
            type="button"
            onClick={() => onToggleExpanded(node.value)}
            className="flex items-center justify-center size-4 shrink-0 text-neutral-80 focus:outline-hidden"
            aria-expanded={isOpen}
            aria-label={`${isOpen ? 'Collapse' : 'Expand'} ${node.label}`}
          >
            <i
              className={clsx(
                'fas fa-chevron-right text-[10px] transition-transform duration-150',
                isOpen && 'rotate-90'
              )}
            />
          </button>

          {/* Branch checkbox */}
          <JxtCheckbox
            name={`tree-branch-${node.value}`}
            label={node.label}
            value={isChecked}
            indeterminate={isIndeterminate}
            disabled={node.disabled}
            onChange={() => onToggleChecked(node)}
          />
        </div>

        {/* Children */}
        {isOpen && (
          <ul className="flex flex-col gap-2 mt-2 pl-8 list-none m-0">
            {(node.children ?? []).map((child) => (
              <TreeNode
                key={child.value}
                node={child}
                checkedValue={checkedValue}
                expandedValue={expandedValue}
                onToggleChecked={onToggleChecked}
                onToggleExpanded={onToggleExpanded}
                depth={depth + 1}
              />
            ))}
          </ul>
        )}
      </li>
    );
  }

  // Leaf node
  return (
    <li className="list-none">
      <JxtCheckbox
        name={`tree-leaf-${node.value}`}
        label={node.label}
        value={isChecked}
        disabled={node.disabled}
        onChange={() => onToggleChecked(node)}
      />
    </li>
  );
};
